export const LOCKED_LABELS = [
  'Inventory',
  'Inventarie',
  'Settings',
  'Inställningar',
] as const

export const SALES_LABELS = ['Sales', 'Försäljning'] as const

export const SIDEBAR_WIDTH_EXPANDED = 220
export const SIDEBAR_WIDTH_COLLAPSED = 44
export const SIDEBAR_COLLAPSED_STORAGE_KEY = 'sidebar-collapsed'
